import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent, CardHeader } from '@/components/ui/card';

/**
 * Skeleton de la RoundCard : conserve la forme generale (en-tete, carte,
 * zone question, zone reponse, bouton) pour eviter le CLS au reveal.
 */
export function RoundSkeleton() {
  return (
    <div className="space-y-6" aria-busy="true" aria-live="polite">
      <div className="text-center space-y-2">
        <Skeleton className="h-3 w-24 mx-auto" />
        <Skeleton className="h-3 w-16 mx-auto" />
      </div>
      <Card className="border-primary/20">
        <CardHeader>
          <Skeleton className="h-5 w-3/4 mx-auto" />
          <Skeleton className="h-5 w-2/3 mx-auto mt-2" />
        </CardHeader>
        <CardContent className="space-y-4">
          <Skeleton className="h-24 w-full" />
          <Skeleton className="h-11 w-full" />
        </CardContent>
      </Card>
      <p className="sr-only">Préparation du round en cours...</p>
    </div>
  );
}

/**
 * Skeleton de la LobbyCard : meme forme generale (titre, code, liste joueurs).
 */
export function LobbySkeleton() {
  return (
    <div className="space-y-6" aria-busy="true" aria-live="polite">
      <div className="text-center space-y-2">
        <Skeleton className="h-8 w-48 mx-auto" />
        <Skeleton className="h-4 w-64 mx-auto" />
      </div>
      <Card>
        <CardHeader>
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-3 w-56 mt-2" />
        </CardHeader>
        <CardContent className="space-y-4">
          <Skeleton className="h-12 w-32 mx-auto" />
          <Skeleton className="h-10 w-full" />
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <Skeleton className="h-5 w-32" />
        </CardHeader>
        <CardContent className="space-y-2">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
        </CardContent>
      </Card>
      <p className="sr-only">Connexion au salon en cours...</p>
    </div>
  );
}
